export default "__VITE_ASSET__DGV574zK__"